import { BrandLockBase, type BrandLockBaseProps } from '@icebreaker/ui';
import { RouterLink } from '../router/router-link';
import { adminBrand } from '../config/env';

/**
 * KİTTEKİ GÖVDEYE marka adını (token katmanı) ve `react-router`ı bağlar.
 *
 * Bileşen DEĞİL enjeksiyondur: prop sözleşmesi `BrandLockBase` ile birebir
 * aynıdır, tek fark iki bağın burada kurulması. Kit çerçeve bilmez
 * (`packages/ui/src/framework-freedom.guard.spec.ts`), bu yüzden bağlama
 * uygulamada yaşar — web tarafındaki `next-boundary` dosyalarının eşleniği.
 */
export function BrandLock(props: Omit<BrandLockBaseProps, 'brandName' | 'linkComponent'>) {
  return <BrandLockBase {...props} brandName={adminBrand.name} linkComponent={RouterLink} />;
}
